"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const skeletonWebAnimation = (secondColor, animationTime) => {
  return {
    animationDuration: `${animationTime}ms`,
    animationTimingFunction: 'ease-in-out',
    animationDelay: '0.5s',
    animationIterationCount: 'infinite',
    animationKeyframes: {
      '50%': {
        backgroundColor: secondColor
      }
    }
  };
};
var _default = exports.default = skeletonWebAnimation;